import { render } from "./ManagerTimesheetCardAttachments.vue?vue&type=template&id=28d5a7c5"
import script from "./ManagerTimesheetCardAttachments.vue?vue&type=script&lang=js"
export * from "./ManagerTimesheetCardAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__